import React, { createContext, useContext, useState, useMemo } from 'react';

const TopBarContext = createContext({
  centerContent: null,
  rightContent: null,
  setTopBarContent: () => {},
  clearTopBarContent: () => {},
});

export const TopBarProvider = ({ children }) => {
  const [centerContent, setCenterContent] = useState(null);
  const [rightContent, setRightContent] = useState(null);

  const setTopBarContent = ({ center = null, right = null } = {}) => {
    setCenterContent(center || null);
    setRightContent(right || null);
  };

  const clearTopBarContent = () => {
    setCenterContent(null);
    setRightContent(null);
  };

  const value = useMemo(() => ({
    centerContent,
    rightContent,
    setTopBarContent,
    clearTopBarContent,
  }), [centerContent, rightContent]);

  return (
    <TopBarContext.Provider value={value}>
      {children}
    </TopBarContext.Provider>
  );
};

export const useTopBar = () => useContext(TopBarContext);

